import axios from 'axios';
import tools from './tools';

// List all course per university
async function listPermissions(queryParams, filters, cancelTokenParam ) {  
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "course__name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; //'no_paginate';
  const offset = queryParams.offset || 0; 
  const owner =  "me";

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/asset-permissions/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset, 
      owner,
      ...filters
    },
    cancelToken: cancelToken.token 
  });

  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function retrievePermission(id, queryParams, cancelTokenParam ) {  
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "course__name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; //'no_paginate';
  const offset = queryParams.offset || 0; 

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/asset-permissions/${id}/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function activateAll(cancelTokenParam ) {
  const cancelToken = cancelTokenParam || axios.CancelToken.source();

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/asset-permissions/active-all/`;  
  const request = axios.post(url, {}, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function deactivateAll(cancelTokenParam ) {
  const cancelToken = cancelTokenParam || axios.CancelToken.source();

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/asset-permissions/deactivate-all/`;  
  const request = axios.post(url, {}, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function isAllActive(cancelTokenParam ) {
  const cancelToken = cancelTokenParam || axios.CancelToken.source();

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/asset-permissions/is-all-active/`;  
  const request = axios.get(url,{
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function updatePermission(bodyData, permissionId, courseId, cancelTokenParam ) {
  bodyData = bodyData || {}; 
  permissionId = permissionId ? permissionId : bodyData.id;
  const cancelToken = cancelTokenParam || axios.CancelToken.source();

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${courseId}/asset-permissions/${permissionId}/`;  
  const request = axios.patch(url, bodyData, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}


export default {
  listPermissions,
  retrievePermission,
  activateAll,
  deactivateAll,
  isAllActive,
  updatePermission,
}